import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { sensorApi } from 'farmx-api';
import {
  initialState,
  requestList,
  receiveListCheckDate,
  requestListFailed,
  requestItemByParams,
  receiveItem,
  requestItemByParamsFailed,
  loadList,
  loadByTypeIdentifier,
} from '../../helpers';

import {
  sensorsAdapter,
  selectSensorStats,
  blockStatsAdapter,
} from '../selectors';

const {
  fetchSensorStatsList,
  fetchCavalierStatsList,
  fetchGatewayStatsList,
  fetchSensorStatsSingle,
  fetchBlockStatsList,
  fetchSingleBlockStats,
} = sensorApi;

const createStatsSlice = (name, getList, getDetail, getRequestState, optionalAdapter) => {
  const loadStatsList = createAsyncThunk(
    `stats/${name}/loadList`,
    loadList({
      getData: getList,
      getRequestState,
    }),
  );

  const loadStatsSingle = createAsyncThunk(
    `stats/${name}/loadSingle`,
    loadByTypeIdentifier({
      getData: getDetail,
      getRequestState: selectSensorStats,
    }),
  );

  const adapter = optionalAdapter || sensorsAdapter;

  const slice = createSlice({
    name,
    initialState: adapter.getInitialState(initialState),
    reducers: {},
    extraReducers: {
      [loadStatsList.pending]: requestList,
      [loadStatsList.fulfilled]: receiveListCheckDate(adapter),
      [loadStatsList.rejected]: requestListFailed,
      [loadStatsSingle.pending]: requestItemByParams(adapter),
      [loadStatsSingle.fulfilled]: receiveItem(adapter),
      [loadStatsSingle.rejected]: requestItemByParamsFailed(adapter),
    },
  });

  return {
    loadStatsList,
    loadStatsSingle,
    slice,
  };
};

const sensorStats = createStatsSlice(
  'sensor',
  fetchSensorStatsList,
  fetchSensorStatsSingle,
  (state) => state.sensorsData.stats.sensor,
);
const cavalierStats = createStatsSlice(
  'cavalier',
  fetchCavalierStatsList,
  fetchSensorStatsSingle,
  (state) => state.sensorsData.stats.cavalier,
);
const gatewayStats = createStatsSlice(
  'gateway',
  fetchGatewayStatsList,
  fetchSensorStatsSingle,
  (state) => state.sensorsData.stats.gateway,
);
const blockStats = createStatsSlice(
  'blockStats',
  fetchBlockStatsList,
  fetchSingleBlockStats,
  (state) => state.sensorsData.stats.block,
  blockStatsAdapter,
);

const {
  loadStatsList: loadSensorStatsList,
  loadStatsSingle: loadSensorStatsSingle,
} = sensorStats;
const {
  loadStatsList: loadCavalierStatsList,
  loadStatsSingle: loadCavalierStatsSingle,
} = cavalierStats;
const {
  loadStatsList: loadGatewayStatsList,
  loadStatsSingle: loadGatewayStatsSingle,
} = gatewayStats;
const {
  loadStatsList: loadBlockStatsList,
  loadStatsSingle: loadBlockStatsSingle,
} = blockStats;

export {
  loadSensorStatsList,
  loadSensorStatsSingle,
  loadCavalierStatsList,
  loadCavalierStatsSingle,
  loadGatewayStatsList,
  loadGatewayStatsSingle,
  loadBlockStatsList,
  loadBlockStatsSingle,
};

export default combineReducers({
  sensor: sensorStats.slice.reducer,
  cavalier: cavalierStats.slice.reducer,
  gateway: gatewayStats.slice.reducer,
  block: blockStats.slice.reducer,
});
